import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { ReturnPeriodRule, rangeValid } from '@/domain/return-conditions'
import {
  OpenKey,
  SetOpenKey,
  ValueSegment,
  bindOpen
} from '@/ui/components/rule-list'
import { NS, formatRange, toDate, toIso } from './utils'

const { Calendar, SegmentedChip } = Base

export const PurchaseRangeChip: React.FC<{
  id: string
  rule: ReturnPeriodRule
  n: number
  editable: boolean
  openKey: OpenKey
  setOpenKey: SetOpenKey
  onChange: (rule: ReturnPeriodRule) => void
}> = ({ id, rule, n, editable, openKey, setOpenKey, onChange }) => {
  const { t, i18n } = useTranslation()
  const valid = rangeValid(rule)
  const from = toDate(rule.start)

  return (
    <SegmentedChip.Root invalid={!valid}>
      <SegmentedChip.Segment emphasis="label">
        {t(`${NS}.purchased`)}
      </SegmentedChip.Segment>
      <SegmentedChip.Segment emphasis="muted">
        {t(`${NS}.between`)}
      </SegmentedChip.Segment>
      <ValueSegment
        label={t(`${NS}.range_label`, { n })}
        summary={
          valid
            ? formatRange(rule.start, rule.end, i18n.language)
            : t(`${NS}.choose_dates`)
        }
        className="max-w-md"
        editable={editable}
        {...bindOpen(`${id}:range`, openKey, setOpenKey)}
      >
        <div className="p-3">
          <Calendar
            mode="range"
            defaultMonth={from}
            selected={{ from, to: toDate(rule.end) }}
            onSelect={(range) =>
              onChange({
                ...rule,
                start: toIso(range?.from),
                end: toIso(range?.to)
              })
            }
          />
        </div>
      </ValueSegment>
    </SegmentedChip.Root>
  )
}
